/**
 * DDX chief complaint fields may store large text as Cloud Storage blob refs (ingest v2+).
 */

/**
 * @typedef {Object} DdxBlobRef
 * @property {true} _ddxBlob
 * @property {string} gcsPath
 * @property {string} sha256
 * @property {number} byteLength
 * @property {string} encoding
 */

export const DDX_BLOB_MARKER = '_ddxBlob';

/**
 * @param {unknown} v
 * @returns {boolean}
 */
export function isDdxBlobRef(v) {
  return !!(
    v &&
    typeof v === 'object' &&
    /** @type {{ _ddxBlob?: boolean, gcsPath?: string, sha256?: string }} */ (v)._ddxBlob === true &&
    typeof /** @type {{ gcsPath?: string }} */ (v).gcsPath === 'string' &&
    typeof /** @type {{ sha256?: string }} */ (v).sha256 === 'string'
  );
}

/**
 * @param {Record<string, unknown> | null | undefined} data - Firestore chief complaint data
 * @returns {boolean}
 */
export function chiefComplaintNeedsHydration(data) {
  if (!data || typeof data !== 'object') return false;
  const md = /** @type {{ metadata?: { hasBlobFields?: boolean } }} */ (data).metadata;
  if (md && md.hasBlobFields) return true;
  const keys = [
    'questionCountRaw',
    'triageRaw',
    'differentialStructuredRaw',
    'emergencyListRaw',
    'adultDdxRaw',
    'reviewerNotesRaw',
  ];
  return keys.some((k) => isDdxBlobRef(data[k]));
}
